import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import Nuevo from './Nuevo.vue'
import Entrar from './Entrar.vue'
import ProductosMios from './Productos-Mios.vue'
import ProductosAlta from './Productos-alta.vue'
import ProductosEditar from './Productos-editar.vue'
import Verfotos from './Verfotos.vue'

Vue.use(VueRouter);

var routes = [
    {path:'/nuevo', name:'nuevo1', component: Nuevo},
    {path:'/entrar', name:'entrar1', component: Entrar},
    {path:'/productosMios', name:'productosMios1', component: ProductosMios},    
    {path:'/productosAlta', name:'productosAl', component: ProductosAlta},  
    {path:'/ProductosEdita', name:'productosEd', component: ProductosEditar},  
    {path:'/Verfotos', name:'verfotos1', component: Verfotos} 

 ];

const router = new VueRouter({
    routes,
    mode: 'history'
})


new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js